const getProductRestockingSoonCount = savedItemProducts =>
  savedItemProducts.filter(
    ({ isRestockingSoon, isProductInStock }) =>
      !!isRestockingSoon && !isProductInStock
  ).length;

export default getProductRestockingSoonCount;
